import PropTypes from "prop-types"
import { Table } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import { VIEW_TYPES } from "helpers/base"
import ContributorsTableGroupHead from "components/contributors-table-group-head"
import { buildScaledCurrencyLabel } from "helpers/metrics/currency-scale-label"

function ContributorsTotal({ disabled, data, viewType, show, openFactorProfile, drift, displayTypeName, factorTable, groupSort, groupOrder, formatter, currencyScale, currency }) {
  return <Table className="exposure-contributors">
    <ContributorsTableGroupHead {...{
      tooltipText: "Exposure",
      displayTypeName,
      groupOrder,
      groupSort,
      label: buildScaledCurrencyLabel(`Exposure (${viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"})`, currencyScale, currency),
    }}
    />
    <ContributorsTableContent
      driftType="Exposure"
      factors
      noPercent
      allFactors
      drift={drift}
      openFactorProfile={openFactorProfile}
      data={sortData(data, groupOrder)}
      show={show}
      factorTable={factorTable}
      disabled={disabled}
      formatter={formatter}
    />
  </Table>
}

ContributorsTotal.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  displayTypeName: PropTypes.string.isRequired,
  openFactorProfile: PropTypes.func,
  show: PropTypes.func.isRequired,
  factorTable: PropTypes.bool.isRequired,
  drift: PropTypes.object.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  formatter: PropTypes.func,
  currencyScale: PropTypes.string,
  currency: PropTypes.string,
}

export default ContributorsTotal
